@if (mappingRuleFormGroup) {
  <form [formGroup]="mappingRuleFormGroup">
    <div class="rule-box">
      <div class="flex gap-4">
        <em-select
          [subscriptSizing]="'dynamic'"
          formControlName="mappingType"
          [label]="'SHARED_LABEL_MAP_FROM' | translate"
        >
          @if (slectedType) {
            <ng-container emPrefix
              ><mat-icon class="text-primary-300">{{
                slectedType?.icon
              }}</mat-icon></ng-container
            >
          }
          <ng-container emSelectTrigger>{{
            slectedType?.title || '' | translate
          }}</ng-container>
          @for (mapType of AvailableMappingTypes; track mapType) {
            <em-option [value]="mapType.type">
              <div class="flex">
                <mat-icon class="text-primary-300">{{ mapType.icon }}</mat-icon>
                {{ mapType.title | translate }}
              </div>
            </em-option>
          }
        </em-select>
        <div>
          @switch (mappingTypeControl.value) {
            @case ('attribute') {
              <div>
                <em-select-operand
                  [availableAttributes]="availableAttributes"
                  [customAttributes]="customAttributes"
                  formControlName="mappingValue"
                  class="block w-[380px]"
                >
                </em-select-operand>
              </div>
            }
            @case ('combine_attributes') {
              <div>
                <em-combine-attributes
                  [availableAttributes]="availableAttributes"
                  [customAttributes]="customAttributes"
                  formControlName="mappingValue"
                ></em-combine-attributes>
              </div>
            }
            @case ('calculation') {
              <div>
                <em-calculation-mapping
                  [availableAttributes]="availableAttributes"
                  [customAttributes]="customAttributes"
                  formControlName="mappingValue"
                ></em-calculation-mapping>
              </div>
            }
            @case ('static_value') {
              <div label="enter static value">
                <em-select-operand
                  [staticValuesOnly]="true"
                  [allowStaticValues]="true"
                  formControlName="mappingValue"
                  class="block w-[380px]"
                >
                </em-select-operand>
              </div>
            }
          }
        </div>
        @if (showActionsMenu) {
          <em-icon-button
            class="ml-auto"
            icon="more_vert"
            color=""
            [matMenuTriggerFor]="actionsMenu"
          ></em-icon-button>
        }
      </div>
    </div>
    @if (showAdditionalProcessor) {
      <div class="if-label mt-3">Transformations:</div>
      <em-additional-processor
        class="ml-12 inline-block"
        [processorFormGroup]="additionalProcessorFormGroup"
      ></em-additional-processor>
    }
    @if (
      conditionalStatementListControl?.value?.conditionalStatements?.length
    ) {
      <div class="if-label mt-3">{{ 'SHARED_LABEL_ONLY_IF' | translate }}:</div>
      <em-conditional-statement-list
        class="ml-12"
        [formGroup]="conditionalStatementListControl"
      >
        <ng-template let-conditionControl>
          <em-condition
            [formGroup]="conditionControl"
            [availableAttributes]="availableAttributes"
            [customAttributes]="customAttributes"
            [operatorGroups]="operatorGroups"
          ></em-condition>
        </ng-template>
      </em-conditional-statement-list>
    }
  </form>
}

<mat-menu #actionsMenu="matMenu">
  @if (showAddCondition) {
    <button mat-menu-item (click)="addCondition()">
      <mat-icon>alt_route</mat-icon>
      <span>{{ 'SHARED_LABEL_ADD_CONDITION' | translate }}</span>
    </button>
  }

  <button mat-menu-item [matMenuTriggerFor]="processors">
    <div class="flex items-center">
      <em-icon name="tune"></em-icon>
      <span>{{ 'SHARED_LABEL_ADD_PROCESSOR' | translate }}</span>
    </div>
  </button>

  @if (allowClearAllConditions) {
    <button mat-menu-item (click)="clearAllConditions()">
      <div class="flex items-center">
        <em-icon name="close" color="warn"></em-icon>
        <span class="text-danger-500">{{
          'SHARED_LABEL_REMOVE_CONDITIONS' | translate
        }}</span>
      </div>
    </button>
  }

  @if (allowDelete) {
    <button mat-menu-item (click)="delete.emit(true)">
      <div class="flex items-center">
        <em-icon name="delete" color="warn"></em-icon>
        <span class="text-danger-500">{{
          'SHARED_LABEL_DELETE' | translate
        }}</span>
      </div>
    </button>
  }
</mat-menu>

<mat-menu #processors="matMenu">
  <button mat-menu-item (click)="addFindReplace()">
    <div class="flex items-center">
      <em-icon name="find_replace"></em-icon>
      <span>{{ 'SHARED_LABEL_FIND_AND_REPLACE' | translate }}</span>
    </div>
  </button>
</mat-menu>
